window.addEventListener('load', frd_mobile_search);

function frd_mobile_search() {
  const search_anchor = document.querySelector('.icon-container a[href="/search"]');
  let search_form = document.querySelector('.shopify-section.shopify-section-group-header-group .search-input');

  if(search_anchor && search_form){
      search_anchor.addEventListener('click', (event) => {
    event.preventDefault();
        
    search_form = document.querySelector('.shopify-section.shopify-section-group-header-group .search-input');

    if(search_form.classList.contains('frd-visible')) {
      search_form.classList.remove('frd-visible');
    } else {
      search_form.classList.add('frd-visible');
    }
  });
  }
}
